// extracted by mini-css-extract-plugin
module.exports = {"header":"home_header__32OE9","footer":"home_footer__2gSjk","body":"home_body__2yeYW","app":"home_app__2arSM","a":"home_a__1zu-X"};